import { EditablePreviewWorld, ObjectRuntimeState } from '../../types'
import { findStateByName } from '../sharedHelpers'

/**
 * ServerStorage 相当のテンプレート本体をプレイ中だけ隠す
 * （見えない・当たらない・触れない）。
 *
 * rjf05（③マト）と rjf09（①ボール/②トラップ）で重複していた 3 連 setter を
 * 1 箇所へ集約する。実機の ServerStorage は描画も物理もされないため、
 * シーンに置いた代役のテンプレートはクローンの複製元としてだけ残す。
 * 物理は visible を見ないため衝突・接触検知も明示的に切る。
 * 表示は次プレイ開始時の world.reset() で復元される。
 */
export const concealServerStorageTemplate = (
  world: EditablePreviewWorld,
  templateId: string,
): void => {
  world.setVisible(templateId, false)
  world.setCanCollide(templateId, false)
  world.setCanTouch(templateId, false)
}

/**
 * 指定名のテンプレート群を隠し、隠蔽前の状態（複製元スナップショット）を
 * テンプレート名 → 状態で返す（同期）。見つかったテンプレートのみ対象。
 * rjs03 / rjs05 / rjs06 / rjf05（③マト）で重複していた
 * 「findStateByName → スナップショット → conceal」の連鎖を 1 箇所へ集約する。
 * 学習者の control_clone 複製への状態復元（常駐監視）も必要な場合は、
 * restoreClonedTemplates.ts の createTemplateCloneRestorer を使うこと。
 */
export const snapshotAndConceal = (
  world: EditablePreviewWorld,
  names: ReadonlyArray<string>,
): ReadonlyMap<string, ObjectRuntimeState> => {
  const snapshotByName = new Map<string, ObjectRuntimeState>()
  for (const name of names) {
    const template = findStateByName(world, name)
    if (!template) {
      continue
    }
    snapshotByName.set(name, { ...template })
    concealServerStorageTemplate(world, template.id)
  }
  return snapshotByName
}
